import useAxios from "src/core/shared/hooks/useAxios";
import {
  PaginatedParams,
  FilterParams
} from "src/core/shared/api";
import {
  EndpointConfig,
  RequestConfig,
  UseApiRequest
} from "src/core/shared/api/config.api";
import { StringResponse } from "src/modules/support/api/support.api";
import { PaginatedData } from "src/library/utils/apiTypes";
import { IOrder } from "src/core/orders/api/orders.api";
import { IDrop } from "src/core/drops/api/drops.api";

export type ListShutdownsParams = { pagination: PaginatedParams<IShutdown>; filters: FilterParams<IShutdown> };
export type UpdateShutdownParams = {shutdownId: number, shutdownUpdate: Partial<IShutdown>};

type ShutdownEndpointConfig = {
  LIST_SHUTDOWNS: EndpointConfig<
    ListShutdownsParams,
    PaginatedData<IShutdown>
  >;
  LIST_BRANCHES_SHUTDOWNS: EndpointConfig<
    ListShutdownsParams,
    PaginatedData<IShutdown>
  >;
  LIST_DROP_SHUTDOWNS: EndpointConfig<
    ListShutdownsParams & { branchId: number; },
    PaginatedData<IShutdown>
  >;
  GET_SHUTDOWN: EndpointConfig<
    number,
    IShutdown
  >;
  DELETE_SHUTDOWN: EndpointConfig<
    number,
    StringResponse
  >;
  CREATE_SHUTDOWN: EndpointConfig<
    Omit<IShutdown, "id">,
    IShutdown
  >;
  UPDATE_SHUTDOWN: EndpointConfig<
  UpdateShutdownParams,
    IShutdown
  >;
};

const requests: RequestConfig<ShutdownEndpointConfig> = {
  LIST_SHUTDOWNS: params => ({
    url: `${process.env.REACT_APP_API_URL}/shutdown/all`,
    method: "GET",
    params
  }),
  LIST_BRANCHES_SHUTDOWNS: params => ({
    url: `${process.env.REACT_APP_API_URL}/shutdown/branches/all`,
    method: "GET",
    params
  }),
  LIST_DROP_SHUTDOWNS: ({ branchId, ...params }) => ({
    url: `${process.env.REACT_APP_API_URL}/shutdown/branch/${branchId}`,
    method: "GET",
    params
  }),
  GET_SHUTDOWN: shutdownId => ({
    url: `${process.env.REACT_APP_API_URL}/shutdown/${shutdownId}`,
    method: "GET"
  }),
  DELETE_SHUTDOWN: shutdownId => ({
    url: `${process.env.REACT_APP_API_URL}/shutdown/${shutdownId}`,
    method: "DELETE"
  }),
  CREATE_SHUTDOWN: shutdown => ({
    url: `${process.env.REACT_APP_API_URL}/shutdown/create`,
    data: shutdown,
    method: "POST"
  }),
  UPDATE_SHUTDOWN: ({ shutdownId, shutdownUpdate }) => ({
    url: `${process.env.REACT_APP_API_URL}/shutdown/${shutdownId}`,
    data: shutdownUpdate,
    method: "PATCH"
  })
};

export const useShutdownsApi: UseApiRequest<ShutdownEndpointConfig> = name => useAxios(requests[ name ], name);

export interface IShutdown {
  id: number;
  startDate: Date;
  endDate: Date;
  reason: string;
  cancelExistingOrders: boolean;
  options: ShutdownOptions | null;
  /** when cutoff is on or before this date and delivery is after, it adds a day to the leadtime */
  extendLeadTime?: boolean;
  branchId?: number;
  branch?: IDrop;
}

export interface ShutdownOptions {
  orderTypesToAllow?: Array<IOrder["type"]>;
}
